import ChampDifficulty from './champion-difficulty';
export default ChampDifficulty;